//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiCell from "../../components/cell/Index.vue";
import HiHeader from "../../components/header/Index.vue";
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../store/mutation-types";

export default {
  name: "PlanEmailPage",
  components: { HiCell, HiHeader },
  created() {},
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
  },
  methods: {
    /**
     * 修改密码点击事件
     */
    changePasswordClick() {
      window.open(process.env.CHANGE_PASSWORD, "_blank");
    },
    /**
     * 修改邮箱点击事件
     */
    changeEmailClick() {
      window.open(process.env.CHANGE_EMAIL, "_blank");
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/my_plan/Email.vue